import AbstractController from "../../../../../vendors/services/abstractController";

import DocumentosService from "../../../../services/documentos.service";
import { useState } from "react";
import FileService from "../../../../services/file.service";
import EventoService from "../../../../services/evento.service";
import ToastService from "../../../../../vendors/services/toastService";
import { Mensagem } from "../../../../shared/mensagem/Mensagem";

export interface ObjectToSendUpload {
  tipoArquivo: number;
  exibicao: string;
  codPropostaNorma: number;
  codigoTema: number;
  ordem: number;
}

export default class DocumentosController extends AbstractController {
  private documentoService: DocumentosService;
  private fileService: FileService;
  private service: EventoService;
  public lista: any;
  public setLista: any;
  public agendarExibicao: any;
  public setAgendarExibicao: any;
  public agendarExecucaoValid: any;
  public setAgendarExecucaoValid: any;
  public tipoArquivo: any;
  public setTipoArquivo: any;
  public tipoArquivoLista: any;
  public setTipoArquivoLista: any;
  public tipoArquivoValid: any;
  public seTipoArquivoValid: any;
  public themeList: any;
  public setThemeList: any;
  public themeValid: any;
  public setThemeValid: any;
  public theme: any;
  public setTheme: any;

  constructor() {
    super();
    [this.lista, this.setLista] = useState([]);
    [this.agendarExibicao, this.setAgendarExibicao] = useState("");
    [this.agendarExecucaoValid, this.setAgendarExecucaoValid] = useState(true);
    [this.tipoArquivo, this.setTipoArquivo] = useState("");
    [this.tipoArquivoLista, this.setTipoArquivoLista] = useState([]);
    [this.tipoArquivoValid, this.seTipoArquivoValid] = useState(true);
    [this.theme, this.setTheme] = useState([]);
    [this.themeList, this.setThemeList] = useState([]);
    [this.themeValid, this.setThemeValid] = useState(true);

    this.documentoService = new DocumentosService();
    this.fileService = new FileService();
    this.service = new EventoService();
  }

  async obterAnexoProposta(id: any) {
    this.start();
    try {
      const res: any = await this.documentoService.getAnexoProposta(id);
      this.stop();

      if (res.result && res.result.length > 0) {
        const sortedArray = res.result.sort(
          (a: any, b: any) => a.nuOrdem - b.nuOrdem
        );

        return sortedArray;
      }
      return [];
    } catch (err) {
      this.stop();
      console.error("Erro ao obter anexos da proposta:", err);
    }
  }

  async getTipoArquivoLista() {
    this.start();
    try {
      const res: any = await this.documentoService.getTipoArquivo();

      this.stop();

      if (res.result && res.result.length > 0) {
        this.setTipoArquivoLista(res.result);
        return res.result;
      }
      return [];
    } catch (err) {
      this.stop();
      console.error("Erro ao obter anexos da proposta:", err);
    }
  }

  dowloadDocumento(codPropostaNorma: number) {
    this.fileService
      .downloadAnexoPropostaNorma(String(codPropostaNorma))
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `documento_${codPropostaNorma}.pdf`;
        link.click();

      })
      .catch((error) => {
        console.error("Erro ao baixar o arquivo:", error);
      });
  }

  downloadTodosAnexos(currentIndex = 0) {
    if (!this.lista || this.lista.length <= 0) {
      return;
    }
    const lista: any = this.lista.map((m: any) => m.codAnexoPropostaNorma);
    if (!lista || lista.length <= 0) {
      ToastService.showWarn('Nenhum anexo encontrado.');
      return;
    }
    this.start();
    if (currentIndex >= lista.length) {
      ToastService.showInfo(Mensagem.DOWNLOAD_MULTIPLOS.replace('$qtde', lista.length));
      this.stop();
      return;
    }
    this.fileService
      .downloadAnexoPropostaNorma(String(lista[currentIndex]))
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `documento_${lista[currentIndex]}.pdf`;
        link.click();
      });

    const next = currentIndex + 1;
    const that = this;
    setTimeout(() => {
      that.downloadTodosAnexos(next);
    }, 5000);
  }


  validaCampo(value: any, setValid: any) {
    setValid(!!value);
    return !!value;
  }

  async obterTema(codigoAudienciaPublica: number) {
    this.start();
    try {
      const res: any = await this.documentoService.getTema(
        codigoAudienciaPublica
      );

      this.stop();

      if (res.result && res.result.length > 0) {
        this.setThemeList(res.result);
        return res.result;
      }
      return [];
    } catch (err) {
      this.stop();
      console.error("Erro ao obter anexos da proposta:", err);
    }
  }
}
